module.exports = __webpack_public_path__ + "img/p39.1d1f509e.png";